import React, { useState } from "react";
import { useSelector } from "react-redux";
import Extension from "../components/extension/extension";
import Search from "../components/search/search";
import Sidebar from "../components/sidebar/sidebar";
import Tour from "../components/tour/tour";
import TypeTour from "../components/tour/type-tour";
import Layout from "../components/layout/layout";
import { Link } from "react-router-dom";

const TourListPage = () => {
  const { user } = useSelector((state) => state.auth);
  const [filters, setFilters] = useState({});
  const [sortBy, setSortBy] = useState(null);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleSortChange = (newSortBy) => {
    setSortBy(newSortBy);
  };

  return (
    <>
      <Layout>
        <div className="content">
          <div className="container">
            <Search />

            {/* <!-- Tour Types --> */}
            <TypeTour />
            {/* <!-- /Tour Types --> */}

            <div className="row">
              {/* <!-- Sidebar --> */}
              <Sidebar onFilterChange={handleFilterChange} />
              {/* <!-- /Sidebar --> */}

              <div className="col-xl-9 col-lg-8 theiaStickySidebar">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h6 className="mb-3">
                    Tour du lịch được tìm thấy trên tìm kiếm của bạn
                  </h6>
                  <Extension onSortChange={handleSortChange} />
                </div>
                {user ? (
                  <div className="bg-info br-10 p-3 pb-2 mb-4">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <p className="fs-14 fw-medium mb-2 d-inline-flex align-items-center">
                        <i className="isax isax-info-circle me-2"></i>Khám phá
                        những bài viết mới nhất trên blog của chúng tôi!
                      </p>
                      <Link to="/blog" className="btn btn-white btn-sm mb-2">
                        Xem blog
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="bg-info br-10 p-3 pb-2 mb-4">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <p className="fs-14 fw-medium mb-2 d-inline-flex align-items-center">
                        <i className="isax isax-info-circle me-2"></i>Tiết kiệm
                        trung bình 15% cho hàng ngàn khách sạn khi bạn đăng nhập
                      </p>
                      <a
                        href="login.html"
                        className="btn btn-white btn-sm mb-2"
                      >
                        Đăng nhập
                      </a>
                    </div>
                  </div>
                )}
                <div className="row justify-content-center">
                  <Tour filters={filters} sortBy={sortBy} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default TourListPage;
